import { atom } from 'jotai';

import getCookies from 'commons/getCookies';

const normalizeCookieValue = (storedValue, initialValue) => {
  if (storedValue == null || storedValue === '') {
    return initialValue;
  }

  if (typeof storedValue === 'string') {
    return storedValue;
  }

  // universal-cookie auto-parses JSON cookie values into objects.
  if (typeof storedValue === 'object') {
    return JSON.stringify(storedValue);
  }

  return String(storedValue);
};

const atomWithCookieStorage = (key, initialValue = '') => {
  const storedValue = normalizeCookieValue(
    getCookies()?.get(key),
    initialValue
  );

  const baseAtom = atom(storedValue);

  return atom(
    get => get(baseAtom),
    (_get, set, nextValue) => {
      set(baseAtom, nextValue);
      getCookies()?.set(key, nextValue.toString(), {
        maxAge: 60 * 60 * 24 * 365, // 1 year
        path: '/',
        sameSite: 'lax',
      });
    }
  );
};

export default atomWithCookieStorage;
